var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "addUser_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.01 5.99c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4m-2 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m-2.95 5h2c3.31 0 6 2.69 6 6v1c0 1.65-1.35 3-3 3h-8c-1.65 0-3-1.35-3-3v-1c0-3.31 2.69-6 6-6m5 8c.55 0 1-.45 1-1v-1c0-2.21-1.79-4-4-4h-2c-2.21 0-4 1.79-4 4v1c0 .55.45 1 1 1zm5-14.01h1.01v.01c.55 0 1 .45 1 1S20.62 7 20.07 7h-1v.99c0 .55-.45 1-1 1s-1-.45-1-1V7h-1c-.55 0-1-.45-1-1s.45-1.01 1-1.01h.99V3.98c0-.55.45-1 1-1s1 .45 1 1z",
  clipRule: "evenodd"
})));
export default SvgAddUser;